<template>
    <div v-if="resultList && resultList.length > 0" class="result-table nopads" style="width: 100%; scrollbar-width: none; -ms-overflow-style: none; border-radius: .5em; border: 1px #d9d9d9;">
        <vue3-datatable
          ref="resultTable"
          :rows="resultList"
          :columns="fields"
          :pagination="false"
          :sticky-header="true"
          height="29em"
          :sortable="true"
          skin="bh-table-compact"
          :row-class="getRowClass"
          cell-class="routa-table-cell"
          @row-click="rowClicked"
      >
          <template #created_time="row">
              {{ getDateString(row.value.created_time) }}
          </template>
          <template #type="row">
              {{ row.value.type.name }}
          </template>
          <template #value="row">
        <span
            v-if="beyondLimit(row.value.value)"
            class="no-pads"
            style="font-weight: bold; color: #c50505"
        > {{ row.value.value }} </span>
              <span
                  v-else
                  class="no-pads"
              > {{ row.value.value }} </span>
          </template>
          <template #street_name="row">
            {{ row.value.street_name ? row.value.street_name : '' }}
          </template>
      </vue3-datatable>
  </div>
</template>

<script>

import {timeUtils} from "@/components/mixins/TimeUtils";
import Vue3Datatable from '@bhplugin/vue3-datatable'

export default {
    name: 'ReportList',
    mixins: [timeUtils],
    components: {Vue3Datatable},
    props: {
       results: {
            type: Array,
            default() {
                return []
            }
        },
        upperLimit: {
           type: Number,
            default: null
        },
        lowerLimit: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            selectedRowId: null,
            fields: [
                {field: 'id', title: this.$t('observations.id'), sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'created_time', title: this.$t('observations.created_time'), sort: true, headerClass: 'routa-table-header'},
                {field: 'type', title: this.$t('observations.type'), sort: true, headerClass: 'routa-table-header'},
                {field: 'value', title: this.$t('observations.value'), sort: true, headerClass: 'routa-table-header'},
                {field: 'road_direction', title: this.$t('observations.direction'), sort: true, headerClass: 'routa-table-header'},
                {field: 'road_number', title: this.$t('observations.road_number'), sort: true, headerClass: 'routa-table-header'},
                {field: 'section_number', title: this.$t('observations.road_section_number'), sort: true, headerClass: 'routa-table-header'},
                {field: 'distance_from_sec_start', title: this.$t('observations.distance_from_sec_start'), sort: true, headerClass: 'routa-table-header'},
                {field: 'city.name', title: this.$t('observations.city'), sort: true, headerClass: 'routa-table-header'},
                {field: 'street_name', title: this.$t('observations.street_name'), sort: true, headerClass: 'routa-table-header'},
            ],
            resultList: []
        }
    },
    watch: {
        results() {
            let temp = []
            this.resultList = []
            this.results.forEach(item => {
                let newItem = item
                newItem.id = item.id
                newItem.created_time = item.created_time
                newItem.road_direction = item.road_direction
                newItem.road_number = item.road_number
                newItem.distance_from_sec_start = item.distance_from_sec_start
                newItem.type = item.type
                newItem.street_name = item.street_name
                newItem.value = item.value
                newItem.section_number = item.section_number
                temp.push(newItem)
            })
            this.$nextTick(() => {
                this.resultList = temp
            })
        }
    },
    mounted() {
        this.resultList = this.results
    },
    methods: {
        getRowClass(row) {
            return row.id === this.selectedRowId ? 'routa-table-row selected-row row-id-' + row.id : 'routa-table-row  row-id-' + row.id
        },

        setSelection(index) {
            this.selectedRowId = null
            if (index >= 0 && index < this.trips.length) {
                this.selectedRowId = this.trips[index].id
            }
        },

        resetSelection() {
            this.selectedRowId = null
        },

        scrollToRow(index) {
            this.$nextTick(() => {
                if (index >= 0 && index < this.results.length) {
                    const targetId = this.results[index].id
                    const rowElement = document.querySelector(`.row-id-${targetId}`)
                    if (rowElement) {
                        rowElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
                    }
                }
            })
        },

        beyondLimit(value) {
            return (this.upperLimit && value > this.upperLimit) || (this.lowerLimit && value < this.lowerLimit)
        },

        rowClicked(item) {
            this.$emit('rowClicked', item)
            this.selectedRowId = item.id
        },
        selectRow(index) {
            this.selectedRowId = this.results[index].id
        }
    }
}
</script>
<style scoped>
</style>
